import React from "react";

const  Error =() => {

    return(
        <>
            <h1>404 Error Page</h1>
            <p>Sorry, This page doesn't exist</p>
            <a href="">GO Back</a>
        </>
    )
}
export default Error;